<template>
	<div class="ola" v-if="getOlaState.olaStateStr">
		<div class="icon" :class="{ success: getOlaState.olaSuccess }">
			<van-icon name="phone-o" />
		</div>
		<div class="text">{{ getOlaState.olaStateStr }}</div>
		<div class="cancel" @click="onHangup">挂断</div>
	</div>
</template>

<script>
import { OlaServer, updateOlaState } from '@/hooks/ola'
import { getOlaSysData, getAskHealthData } from '@/api/index'
import eventBus from '@/hooks/eventBus'

import { mapGetters } from 'vuex';
export default {
	props: {
		extNo: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			olaServer: null
		}
	},
	methods: {
		onHangup() {
			this.olaServer?.hangup();
		},
		// 初始化
		async init() {
			if (!this.extNo) return false;
			try {
				const { data } = await getOlaSysData()
				this.olaServer = new OlaServer(data.ip, data.port, data.queue, this.extNo, data.extPwd);
				eventBus.on('olaDial', async (askNo, phone) => {
					if (this.getOlaState.olaDisabled) return false;
					try {
						if (!phone) {
							updateOlaState('olaBusy', true)
							const { data: { memberInfo: { mobile } } } = await getAskHealthData({ askNo });
							if (mobile) phone = mobile;
							else updateOlaState('olaBusy', false)
						}
						if (phone) {
							this.olaServer?.dial(phone, askNo);
						} else {
							updateOlaState('olaBusy', false)
						}
					} catch (error) {
						updateOlaState('olaBusy', false)
					}
				})
			} catch (error) {
				console.log(error);
			}
		}
	},
	mounted() {
		this.init()
	},
	computed: {
		...mapGetters(['getOlaState']),
	},
	destroyed() {
		this.olaServer?.destory();
	}
}
</script>
<style lang="scss" scoped>
.ola {
	position: fixed;
	right: 20px;
	bottom: 20px;
	z-index: 999;
	display: flex;
	align-items: center;
	background: #fff;
	box-shadow: 0 0 10px rgba(0, 0, 0, .1);
	padding: 10px;
	border-radius: 50px;

	.icon {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: #ee0a24;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 22px;

		&.success {
			background: #07c160;
		}
	}

	.text {
		padding: 0 10px;
		font-size: 16px;
	}

	.cancel {
		background: #ee0a24;
		color: #fff;
		padding: 3px 10px;
		border-radius: 50px;
		cursor: pointer;
		font-size: 16px;
		&:hover {
			opacity: .85;
		}
	}
}
</style>